require('fg-frontend/third/highslide/highslide-full');
var $ = require('jquery');

var hs = window.hs;

hs.graphicsDir = '/img/highslide/';
hs.transitions = ['expand', 'crossfade'];
hs.objectLoadTime = 'before'; // Load iframes 'before' or 'after' expansion.
hs.outlineType = null;
hs.align = 'center';
hs.dimmingOpacity = 0.7;
hs.numberOfImagesToPreload = 0;
hs.fullExpandPosition = 'top left';

hs.cacheAjax = false;
hs.preserveContent = false;

// credits off
hs.showCredits = false;
hs.creditsHref = '';
hs.lang.creditsText = '';
hs.lang.creditsTitle = '';
hs.captionEval = 'this.a.title';
hs.marginTop = 50;

if (hs.registerOverlay) {
    hs.registerOverlay({
        fade: 2,
        hideOnMouseOut: false,
        html: '<a href="javascript:" onclick="return hs.close(this)" class="closebutton">Zavřít</a>',
        useOnHtml: true,
        position: 'top right'
    });
}

hs.Expander.prototype.onInit = function(sender) {
	return $(document).data('hsStandardGalleryEnabled') == '1' || $(sender.a).data('openAnyway') == '1';
};

hs.Expander.prototype.onBeforeClose = function() {
	$(document).data('hsStandardGalleryEnabled', '0');
};


hs.Expander.prototype.onBeforeExpand = function(sender) {
	/**
	 * custom caption
	 */

	if (sender.thumb && ($(sender.thumb).data('title') && $(sender.thumb).data('title') != "" || sender.thumb.alt && sender.thumb.alt != "" )) {

		var $photoTitle = $('<div class="highslide-custom-caption"></div>');
		var $photoTitleContent = $('<div class="highslide-custom-caption-in"></div>').appendTo($photoTitle);
		var text = '';
		if(sender.thumb.alt != ''){
			text += sender.thumb.alt;
			if ($(sender.thumb).data('title') && $(sender.thumb).data('title') != "") {
				text += '<br>';
			}
		}
		text += $(sender.thumb).data('title') || '';
		$photoTitleContent.html(text);
		sender.createOverlay( { overlayId: $photoTitle.get(0), position: "bottom center", hideOnMouseOut: true, opacity: 1, width: '100%' } );

	}

	/**
	 * highslide navigace
	 */
	var arrowLeft = document.createElement('div');
	var arrowRight = document.createElement('div');

	if (sender.getAdjacentAnchor(-1)) {
		arrowLeft.innerHTML = '<a href="javascript:" onclick="return hs.previous(this)" title="Předchozí" class="highslide-previous"><span class="icon-awesome icon-awesome-angle-left"></span></a>';
		arrowLeft.className = "controlbar-arrows";
	}
	if (sender.getAdjacentAnchor(1)) {
		arrowRight.innerHTML = '<a href="javascript:" onclick="return hs.next(this)" title="Následující" class="highslide-next"><span class="icon-awesome icon-awesome-angle-right"></span></a>';
		arrowRight.className = "controlbar-arrows";
	}
	if (arrowLeft.innerHTML != "") {
		sender.createOverlay({ overlayId: arrowLeft, position: "middle left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2 });
	}
	if (arrowRight.innerHTML != "") {
		sender.createOverlay({ overlayId: arrowRight, position: "middle right", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2 });
	}
};


hs.addEventListener(window, 'resize', function() {
	var expanders = hs.expanders,
		expandDuration = hs.expandDuration,
		restoreDuration = hs.restoreDuration,
		i = expanders.length,
		a,
		exp;
// make it quick
	hs.expandDuration = 0;
	hs.restoreDuration = 0;

	while (i--) {
		exp = expanders[i];
		if (exp) {
			a = exp.a;
			exp.close();
			$(document).data('hsStandardGalleryEnabled', '1');
			a.onclick();
		}
	}

// reset durations
	setTimeout(function() {
		hs.expandDuration = expandDuration;
		hs.restoreDuration = restoreDuration;
	}, expandDuration);
});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/highslide-settings.js